<template>
  <div>
    <modal :class-style="'welcone-pad'" :modal-key="'profile_level_up_modal'" @close="$emit('close')" class="modal--welcomeback modal_svg">
      <template slot="header">
        <h1>{{ getTranslations.home_profile_profile_level }} {{ userInfo.level }}</h1>
        <p>{{ getTranslations.home_modals_profile_level_complete_level_part1 }} {{ gamesRequired }} {{ getTranslations.home_modals_profile_level_complete_level_part2 }}</p>
        <img src="static/images/bonus_points.svg" alt="">
      </template>
      <template slot="body" class="welcone-pad">
        <p>{{ numberFormatting(userInfo.pointsOfNextLevel) }} {{ getTranslations.home_modals_profile_level_bonus_points }}</p>
        <div class="progress_games_won">
          <img src="static/images/trophy_mod.svg" alt="">
          <span class="color">{{ userInfo.currentLevelGamesWon }}</span>
          <span>{{ getTranslations.home_profile_default_content_games_won }}</span>
        </div>
        <div class="progress-barv2 modal_bar">
          <div class="bar level" :data-size="gamesWonPercentRatio">
            <span class="perc"></span>
          </div>
        </div>
        <div class="progress_games_level">
          <img src="static/images/rocket_mod.svg" alt="">
          <span class="color">{{ gamesRequired }}</span>
          <span>{{ getTranslations.home_modals_profile_level_games_to_level_up  }}</span>
        </div>
        <div class="new_game_buttons_section ">
          <h2>{{ getTranslations.home_modals_profile_level_start_new_game  }}</h2>
          <div class="btn_left">
            <p>{{ getTranslations.home_modals_profile_level_random_game  }}</p>
            <a href="#" @click.prevent="playRandom()">
              <img src="static/images/random_icon.svg" alt="">
            </a>
          </div>
          <div class="btn_right">
            <p>{{ getTranslations.home_modals_profile_level_against_friend  }}</p>
            <a style="cursor:pointer" @click.prevent="playFriend()">
              <img src="static/images/friend_icon.svg" alt="">
            </a>
          </div>
        </div>
      </template>
    </modal>
    <search-specific-user v-if="showSearchModal" @close="showSearchModal = false"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { loading } from '@/common/jQuery';
import Modal from '@/components/home/modals/shared/GenericModal';
import NumbersFormattingMixin from '@/common/mixins/numbersFormatting';
import SearchSpecificUser from '@/components/home/modals/users/SearchSpecificOpponent';
import NewGameMixin from '@/common/mixins/home';

export default {
  name: 'profile-level-up',
  mixins: [NumbersFormattingMixin, NewGameMixin],
  data() {
    return {
      showSearchModal: false,
    };
  },
  props: {
    userInfo: Object,
  },
  components: {
    SearchSpecificUser,
    Modal,
  },
  mounted() {
    this.renderProgressBar();
  },
  updated() {
    this.renderProgressBar();
  },
  methods: {
    playRandom() {
      this.playGame();
    },
    playFriend() {
      this.showSearchModal = true;
    },
    renderProgressBar() {
      loading();
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    gamesRequired() {
      return this.userInfo.currentLevelGamesWon + this.userInfo.gamesToNextLevel;
    },
    gamesWonPercentRatio() {
      if (!this.gamesRequired) return 0;
      return Math.round((this.userInfo.currentLevelGamesWon / this.gamesRequired) * 100);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/profile/ProfileLevelUp.vue